// extracted by mini-css-extract-plugin
export default {"home_business":"Business2_home_business__3jZxJ","more_btn":"Business2_more_btn__9oROW"};